import { render, staticRenderFns } from "./Returns.vue?vue&type=template&id=004474cc&scoped=true&"
import script from "./Returns.vue?vue&type=script&lang=js&"
export * from "./Returns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004474cc",
  null
  
)

export default component.exports